<app-merchant-details
  [identity]="identity"
  [merchant]="merchant"
  [merchants]="recentMerchants"
></app-merchant-details>
<form
  name="settlementForm"
  novalidate
  angular-Validator
  ng-submit="settlementForm.$valid && saveMerchantSettlement(settlementDetail)"
  *ngIf="hasEntitlement('MERCHANTS_SETTLEMENT_INFO')"
>
  <div
    id="settlementDetails"
    class="card card-nc"
    document-click="clearActionTips($event)"
  >
    <div class="card-heading ">
      <i class="fa fa-credit-card"></i
      ><span class="cardHeaderHeading"> SETTLEMENT INFORMATION </span
      >&nbsp;&nbsp;
      <span
        class="pull-right save-card"
        *ngIf="hasEntitlement('MERCHANTS_SETTLEMENT_UPDATE')"
      >
        <button
          type="submit"
          [disabled]="saving"
          *ngIf="
            !isAutoSettleTypeError &&
            settlementDetail &&
            settlementDetail.autoSettleModifiable === 'Y'
          "
          class="btn btn-nc"
          (click)="saveMerchantSettlement(settlementDetail)"
        >
          SAVE <i [ngClass]="{ 'fa fa-spinner fa-spin': saving }"></i>
        </button>
      </span>
    </div>
    <div class="card-body">
      <div class="row" *ngIf="!dataLoading && isAutoSettleTypeError">
        <div class="form-group col-md-12">
          <label for="settlementType" class="control-label labelCommon">
            Settlement Type:
          </label>
          <span class="text-error" style="color:RED"
            ><strong
              >Settlement type is setup incorrectly, please contact Navy Cash
              Technical Support</strong
            ></span
          >
        </div>
      </div>
      <div class="row" *ngIf="dataLoading">
        <div class="form-group col-md-12">
          <i class="fa fa-spinner fa-spin fa-4x"></i>
        </div>
      </div>
      <div
        class="row"
        *ngIf="
          !dataLoading &&
          settlementDetail &&
          !isAutoSettleTypeError &&
          filterSettlementTypes.length > 0
        "
      >
        <div class="col-md-4">
          <label
            for="settlementEligible"
            class="col-md-12 control-label labelCommon"
          >
            Settlement Eligible
          </label>
          <div class="form-group col-md-12">
            <span name="settlementEligible" class="staticText1">{{
              settlementDetail.autoSettleEligible | yesNo
            }}</span>
          </div>
        </div>
        <div class="col-md-4">
          <label
            for="settlementType"
            class="col-md-12 control-label labelCommon"
          >
            Settlement Type
          </label>
          <div
            class="form-group col-md-12"
            *ngIf="
              hasEntitlement('MERCHANTS_SETTLEMENT_UPDATE') &&
              settlementDetail &&
              settlementDetail.autoSettleModifiable != 'N'
            "
          >
            <select
              id="settlementType"
              class="form-control input-sm"
              name="settlementType"
              [(ngModel)]="settlementDetail.autoSettleType"
              required
            >
              <option
                *ngFor="let settlementType of filterSettlementTypes"
                [value]="settlementType.id"
                >{{ settlementType.value }}</option
              >
            </select>
          </div>
          <div
            class="form-group col-md-12"
            *ngIf="
              settlementDetail &&
              (!hasEntitlement('MERCHANTS_SETTLEMENT_UPDATE') ||
                settlementDetail.autoSettleModifiable != 'Y')
            "
          >
            <span
              ><strong>{{
                getSettlementTypeString(settlementDetail.autoSettleType)
              }}</strong></span
            >
          </div>
        </div>
        <div class="col-md-4">
          <label
            for="settlementEligible"
            class="col-md-12 control-label labelCommon"
          >
            Settlement Schedule
          </label>
          <div
            class="form-group col-md-12"
            *ngIf="
              hasEntitlement('MERCHANTS_SETTLEMENT_UPDATE') &&
              settlementDetail &&
              settlementDetail.autoSettleModifiable != 'N'
            "
          >
            <select
              id="settlementSchedule"
              class="form-control input-sm"
              name="settlementSchedule"
              [disabled]="settlementDetail.autoSettleModifiable === 'N'"
              [(ngModel)]="settlementDetail.autoSettleSchedule"
              required
            >
              <option
                *ngFor="let settlementSchedule of settlementSchedules"
                [value]="settlementSchedule.id"
                >{{ settlementSchedule.value }}</option
              >
            </select>
          </div>
          <div
            class="form-group col-md-12"
            *ngIf="
              settlementDetail &&
              (!hasEntitlement('MERCHANTS_SETTLEMENT_UPDATE') ||
                settlementDetail.autoSettleModifiable != 'Y')
            "
          >
            <span
              ><strong>{{
                getSettlementScheduleString(settlementDetail.autoSettleSchedule)
              }}</strong></span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
<div
  class="card card-nc"
  *ngIf="hasEntitlement('MERCHANTS_SETTLEMENT_HISTORY')"
>
  <div class="card-heading">
    <div class="row">
      <div class="col-md-4 col-xs-4">
        <span class="icon-NC_history"></span
        ><span class="cardHeaderHeading"> SETTLEMENT HISTORY 1 YEAR</span>
      </div>
      <div class="col-md-4 datepicker inline col-xs-4">
        <div class="row">
          <div class="col-xs-3 col-md-3 calHeading">Start Date</div>
          <div class="col-xs-8 col-md-8">
            <div class="input-group datepicker dtpicker-btn">
              <input
                id="startDate"
                name="startDate"
                readonly="readonly"
                class="form-control"
                [ngModel]="startDate"
                (ngModelChange)="startDate = $event"
                [minDate]="maxDate"
                [maxDate]="endDate"
                (dateSelect)="loadSettlementHistory()"
                ngbDatepicker
                #dp="ngbDatepicker"
                (click)="dp.toggle()"
              />
              <div class="input-group-append">
                <button
                  type="button"
                  class="fa fa-calendar"
                  (click)="dp.toggle()"
                ></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 datepicker inline col-xs-4">
        <div class="row">
          <div class="col-xs-3 col-md-3 calHeading">End Date</div>
          <div class="col-xs-8 col-md-8">
            <div class="input-group datepicker dtpicker-btn">
              <input
                id="endDate"
                name="endDate"
                readonly="readonly"
                class="form-control"
                [ngModel]="endDate"
                (dateSelect)="loadSettlementHistory()"
                (ngModelChange)="endDate = $event"
                [minDate]="startDate"
                #dp2="ngbDatepicker"
                ngbDatepicker
                (click)="dp2.toggle()"
              />
              <div class="input-group-append">
                <button
                  type="button"
                  class="fa fa-calendar"
                  (click)="dp2.toggle()"
                ></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <table class="table tableBackground tableRow table-bordered table-hover">
    <thead class="transactionHistHeader tableheading">
      <tr>
        <th class="text-center">PAY DATE</th>
        <th class="text-center">BATCH</th>
        <th class="text-center">TOTAL SALES</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="settlementHistoryDetails.length === 0 && !loadingHistory">
        <td colspan="7" style="text-align: center; height: 150px;">
          No settlement activity found for this period.
        </td>
      </tr>
      <tr *ngIf="loadingHistory">
        <td colspan="7" style="text-align: center; height: 150px;">
          <i class="fa fa-spinner fa-2x fa-pulse"></i>
        </td>
      </tr>
      <tr *ngFor="let settlementHistoryDetail of settlementHistoryDetails">
        <td class="transactionHistText text-center">
          {{ settlementHistoryDetail.payDate | date: 'MM/dd/yyyy ' }}
        </td>
        <td class="transactionHistText text-center">
          {{ settlementHistoryDetail.batchId }}
        </td>
        <td class="transactionHistText text-center">
          {{ settlementHistoryDetail.totalSales | currency }}
        </td>
      </tr>
    </tbody>
  </table>
</div>
